import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';

@Component({
    selector: 'scitis-machine-delete',
    templateUrl: './machine-delete.component.html',
    styleUrls: ['./machine-delete.component.scss'],
    standalone: false
})
export class MachineDeleteComponent implements OnInit {

  @Input()
  machineName: string = '';

  deleteMachineMessageBody: string = '';
  deleteMessageWarning: string = '';

  constructor(private activeModal: NgbActiveModal,
              private translateService: TranslateService) {
    this.deleteMachineMessageBody = this.translateService.instant('Do you really want to permanently delete the machine %machine and pages?');
    this.deleteMessageWarning = this.translateService.instant('*Note. A task will be scheduled to delete %machine and cleanup dependencies. Please reload the page a bit later!');
  }


  ngOnInit(): void {
    this.deleteMachineMessageBody = this.deleteMachineMessageBody.replace('%machine', this.machineName.toBold());
    this.deleteMessageWarning = this.deleteMessageWarning.replace('%machine', this.machineName.toBold());
  }

  onClose(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel(): void {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onDelete() {
    this.activeModal.close(ModalDialogDismissOption.OK);
  }
}
